import React from "react";
import logo from "./logo.svg";
import "./App.css";
import PingPongContainer from "./containers/nx-ping-pong-container";
import { Card, Chip, colors, Divider, makeStyles, Typography } from "@material-ui/core";
import PrimarySearchAppBar from "./components/AppBar";
import * as _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column"
  },
  contentColumns: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "calc(100% - 64px)",
    overflow: "auto"
  },
  contentColumnPadding: {
    padding: "20px"
  },
  contentColumnPaddingflexGrow: {
    padding: "20px",
    flexGrow: 1,
    flexShrink: 1,
    height: "calc(100% - 40px)",
    overflow: "auto"
    //backgroundColor: "rgb(240,240,240)"
  },
  squareMarginedChip: {
    borderRadius: "2px",
    marginRight: "8px",
    marginBottom: "8px",
    cursor: "pointer"
  },
  squareMarginedSelectedChip: {
    borderRadius: "2px",
    marginRight: "8px",
    marginBottom: "8px",
    backgroundColor: colors.blue[500],
    color: "white",
    fontWeight: "bold",
    cursor: "pointer"
  },
  maxWidth200FlexWrap: {
    maxWidth: "200px",
    minWidth: "200px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  marginBottom8: { marginBottom: "8px", width: "fit-content" },
  noBorder100Width100Height: {
    border: "none",
    height: "auto",
    overflow: "none",
    width: "100%"
  },
  flexRow: {
    display: "flex",
    flexDirection: "row"
  },
  flexRowWrap: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center"
  },
  marginBottomRight20: {
    marginBottom: "20px",
    marginRight: "20px"
  },
  alignCenter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  marginTop22FlexWrap: {
    marginTop: "22px",
    flexWrap: "wrap"
  }
}));

const tags = [
  "Quote",
  "Order",
  "Opportunity",
  "Global",
  "Clone",
  "Extend",
  "Feature",
  "Request",
  "Issue",
  "Bug",
  "Problem",
  "Weather",
  "Other"
];

const cards = [
  {
    name: "Clone Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/Clone Card.png",
    tags: ["Quote", "Clone", "Order", "Opportunity"]
  },
  {
    name: "Extend Quote Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/Extend Quote Card.png",
    tags: ["Quote", "Extend"]
  },
  {
    name: "Feature Request Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/Feature Request Card.png",
    tags: ["Feature", "Request"]
  },
  {
    name: "Issue Report Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/Issue Report Card.png",
    tags: ["Issue", "Bug", "Problem"]
  },

  {
    name: "My Orders Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/My Orders Card.png",
    tags: ["Order"]
  },
  {
    name: "Weather Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/Weather Card.png",
    tags: ["Weather"]
  },
  {
    name: "Leave Status Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/Leave Status Card.png",
    tags: ["Leave"]
  },
  {
    name: "Leave Request Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/Leave Request Card.png",
    tags: ["Leave", "Request"]
  },
  {
    name: "No Card Found Card",
    url: "https://websitetestdata.blob.core.windows.net/img/card-me/No Card Found Card.png",
    tags: ["Other"]
  }
];

function App() {
  const classes = useStyles();
  const [selectedTags, setSelectedTags] = React.useState({});
  const [searchFilter, setSearchFilter] = React.useState("");

  const onChipClick = (tag) => {
    let selectedTagsCopy = { ...selectedTags };

    if (selectedTagsCopy[tag] == null) {
      selectedTagsCopy[tag] = "clicked";
    } else {
      delete selectedTagsCopy[tag];
    }

    setSelectedTags(selectedTagsCopy);
  };

  const searchFilteredCards =
    searchFilter != null && searchFilter.trim() != ""
      ? _.filter(cards, (card) => card.name.toLowerCase().indexOf(searchFilter.trim().toLowerCase()) != -1)
      : cards;

  return (
    <div className={classes.root}>
      <PrimarySearchAppBar searchFilter={searchFilter} setSearchFilter={setSearchFilter} />

      <div className={classes.flexRow} style={{ flexGrow: 0 }}>
        <div className={classes.contentColumnPadding}>
          <div>
            <Typography className={classes.marginBottom8} variant="h6">
              Tags
            </Typography>
          </div>
        </div>
        <div className={classes.marginTop22FlexWrap}>
          {_.map(tags, (tag) => (
            <Chip
              className={selectedTags[tag] == null ? classes.squareMarginedChip : classes.squareMarginedSelectedChip}
              label={tag}
              clickable={false}
              onClick={() => onChipClick(tag)}
            />
          ))}
        </div>
      </div>

      <div className={classes.contentColumns}>
        <div className={classes.contentColumnPaddingflexGrow}>
          <div className={classes.flexRowWrap}>
            {_.map(searchFilteredCards, (card) => {
              if (JSON.stringify(selectedTags) === "{}") {
                return (
                  <div className={classes.marginBottomRight20}>
                    <img className={classes.noBorder100Width100Height} src={card.url} />
                  </div>
                );
              }
              let tagMatched = false;
              _.each(card.tags, (tag) => {
                if (selectedTags[tag] != null) {
                  tagMatched = true;
                }
              });
              return tagMatched ? (
                <div className={classes.marginBottomRight20}>
                  <img className={classes.noBorder100Width100Height} src={card.url} />
                </div>
              ) : null;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
